import React, { useEffect } from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Solutions from "./components/Solutions";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import CloudMarketplacePage from "./components/marketplace/CloudMarketplacePage";
import ITDistributorsPage from "./components/distributors/ITDistributorsPage";
import MSPsPage from "./components/msps/MSPsPage";
import TelcosPage from "./components/telcos/TelcosPage";
import ContractsPage from "./components/contracts/ContractsPage";
import ContactPage from "./components/contact/ContactPage";
import AboutPage from "./components/about/AboutPage";
import PrivacyPage from "./components/legal/PrivacyPage";
import TermsPage from "./components/legal/TermsPage";
import SolutionLayersPage from "./components/solutions/SolutionLayersPage";
import APMPage from "./components/apm/APMPage";
import ModulePage from "./components/modules/ModulePage";
import ModulesOverviewPage from "./components/modules/ModulesOverviewPage";
import SupportPage from "./components/support/SupportPage";
import SEO from "./components/SEO";

// Component to handle scroll to anchor on navigation
const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Small delay to ensure the page has rendered
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

const LandingPage = () => {
  const homeStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'asisant',
    url: 'https://asisant.com',
    logo: 'https://customer-assets.emergentagent.com/job_asisant-portal/artifacts/zw52s0v6_logo_color.png',
    description: 'Plataforma cloud con la que distribuidores IT, MSPs y telcos operan a sus clientes de extremo a extremo: marketplace multivendor, provisionamiento automático, suscripciones, billing, observabilidad, Starlink, ITAM, GRC y más.',
    sameAs: [],
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="Opera clientes, marketplace y provisionamiento cloud"
        description="asisant es mucho más que un marketplace: opera a tus clientes de extremo a extremo con provisionamiento automático, billing, observabilidad de servicios, Starlink, ITAM, GRC, FinOps, CRM e IA. Plataforma modular para partners, CSP, MSPs y telcos."
        keywords="asisant, operación de clientes, provisionamiento cloud, marketplace multivendor, CSP, MSP, billing, observabilidad, Starlink, bolsas de datos, ITAM, GRC, FinOps, CRM, IA"
        canonical="/"
        structuredData={homeStructuredData}
      />
      <Navbar />
      <Hero />
      <Solutions />
      <Features />
      <HowItWorks />
      <Testimonials />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToAnchor />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/cloud-marketplace" element={<CloudMarketplacePage />} />
            <Route path="/distribuidores-it" element={<ITDistributorsPage />} />
            <Route path="/msps" element={<MSPsPage />} />
            <Route path="/telcos" element={<TelcosPage />} />
            <Route path="/automatizacion-contratos" element={<ContractsPage />} />
            <Route path="/contacto" element={<ContactPage />} />
            <Route path="/sobre-nosotros" element={<AboutPage />} />
            <Route path="/privacidad" element={<PrivacyPage />} />
            <Route path="/terminos" element={<TermsPage />} />
            <Route path="/soluciones-avanzadas" element={<SolutionLayersPage />} />
            <Route path="/apm" element={<APMPage />} />
            <Route path="/modulos" element={<ModulesOverviewPage />} />
            <Route path="/modulos/:slug" element={<ModulePage />} />
            <Route path="/soporte" element={<SupportPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
